import { formatCurrency } from '@c2s-npm/plumlib';
import classNames from 'classnames';
import React from 'react';

export const Asset = ({
  asset = {},
  hasPremium,
  hasOtherElements,
  restrictionInfo = {},
  children,
  className = '',
  tooltip,
  ...props
}) => {
  const { fee, restrictionType } = asset;

  const enabled =
    !fee ||
    (!restrictionInfo.restrictPremium &&
      (!restrictionInfo.limit || restrictionInfo.limit === restrictionType));
  const disabled = !enabled;

  return (
    <div {...props} className={classNames('t-relative t-overflow-hidden', className)} title={tooltip}>
      {children}
      {!!fee && (
        <div className='t-absolute t-bottom-[2px] t-left-0 t-right-0 t-mx-auto t-flex t-min-h-[30px] t-w-[calc(100%_-_4px)] t-max-w-[100px] t-flex-col t-items-center t-justify-center t-rounded-b-2xl t-bg-white t-bg-opacity-80 t-text-center t-text-2xs t-font-medium t-text-muted'>
          {/* <span className='t-block'>Premium</span>{' '} */}
          <span
            className={classNames('t-block t-leading-[12px]', {
              't-font-bold t-text-onsale': !!fee.usualRate,
              't-text-brand-black': !fee.usualRate,
            })}>
            {formatCurrency(fee.rate)}
          </span>
          {/* {fee.usualRate && (
            <span className='t-block t-scale-90 t-leading-[12px] t-text-muted t-line-through'>
              {currency(fee.usualRate)}
            </span>
          )} */}
        </div>
      )}
      {disabled && (
        <div className='t-absolute t-bottom-0 t-left-0 t-right-0 t-top-0 t-bg-white t-opacity-70' />
      )}
    </div>
  );
};
